// extracted by mini-css-extract-plugin
export default {"wrapper":"vP-z"};